import { configureStore } from "@reduxjs/toolkit";

// import assessmentReducer from './assessmentSlice'
// import userReducer from './userSlice'
import logger from "redux-logger";
import userReducer from "./auth/userCredSlice";
import getApiReducer from "./api/getApi/getApiSlice"
import patchApiReducer from "./api/patchApi/patchApiSlice"
import deleteApiReducder from "./api/deleteApi/deleteApiSlice"

const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
  reducer: {
    // assessment: assessmentReducer,
    user: userReducer,
    getApi: getApiReducer,
    patchApi: patchApiReducer,
    deleteApi: deleteApiReducder
    // Add other reducers if needed
  },
});

export default store;
